import { autoserialize } from 'cerialize';
import { Address } from './address';

export class VerifiedAddress {
  @autoserialize
  requestedAddress: Address;

  @autoserialize
  error: string;

  @autoserialize
  suggestedAddresses: Array<Address>;
}
